export default __webpack_public_path__ + "static/media/741.f53ddcaa.png";